import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { darkColors } from '@tryhackme/thm-ui-components';
export const StyledQuestionHintContent = styled.article`
  padding: 5.6rem 0.9rem 2.4rem;
  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    padding-top: 0;
  }
`;
export const StyledHintTitle = styled.div`
  display: flex;
  margin-bottom: 2.4rem;
`;
export const StyledLightBulb = styled(FontAwesomeIcon)`
  width: 2.8rem;
  height: 2.8rem;
  margin-right: 1rem;
  color: ${darkColors.warning.main};
`;
export const StyledTitle = styled.p`
  font-family: ${({
  theme
}) => theme.fonts.familyUbuntu};
  font-weight: ${({
  theme
}) => theme.fonts.weight.semiBold};
  font-size: 2.4rem;
  line-height: 2.758rem;
  color: ${({
  theme
}) => theme.colors.grey[100]};
`;
export const TextContainer = styled.p`
  font-family: ${({
  theme
}) => theme.fonts.familySansPro};
  font-weight: ${({
  theme
}) => theme.fonts.weight.regular};
  font-size: ${({
  theme
}) => theme.fonts.sizes.default};
  line-height: ${({
  theme
}) => theme.fonts.lineHeight.default};
  color: ${({
  theme
}) => theme.colors.grey[100]};
`;